module.exports = __webpack_public_path__ + "static/7-f5a7d344e1ab3de4c723fc7a17d114f9.png";